var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcesspayroll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#066161",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 17C24.5 21.14 21.14 24.5 17 24.5C12.86 24.5 9.5 21.14 9.5 17C9.5 12.86 12.86 9.5 17 9.5",
    stroke: "#066161",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8571 18.5002C14.8571 19.3317 15.5 20.0002 16.2886 20.0002H17.9C18.5857 20.0002 19.1429 19.4174 19.1429 18.6888C19.1429 17.9088 18.8 17.626 18.2943 17.446L15.7143 16.546C15.2086 16.366 14.8657 16.0917 14.8657 15.3031C14.8657 14.5831 15.4229 13.9917 16.1086 13.9917H17.72C18.5086 13.9917 19.1514 14.6603 19.1514 15.4917",
    stroke: "#066161",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0001 13.1428V20.8571",
    stroke: "#066161",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7954 11.1876C23.2022 11.1876 23.532 10.8578 23.532 10.451C23.532 10.0441 23.2022 9.71436 22.7954 9.71436C22.3886 9.71436 22.0588 10.0441 22.0588 10.451C22.0588 10.8578 22.3886 11.1876 22.7954 11.1876Z",
    stroke: "#066161",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7851 13.2321C24.0614 13.2321 24.2932 13.0019 24.202 12.741C24.1286 12.5314 24.0087 12.3387 23.8487 12.1786C23.5692 11.8992 23.1903 11.742 22.7952 11.7417C22.3999 11.7417 22.0208 11.8987 21.7413 12.1782C21.5811 12.3385 21.4611 12.5314 21.3879 12.7414C21.2969 13.0022 21.5286 13.2321 21.8048 13.2321H23.7851Z",
    stroke: "#066161",
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6332 11.1876C21.04 11.1876 21.3698 10.8578 21.3698 10.451C21.3698 10.0441 21.04 9.71436 20.6332 9.71436C20.2264 9.71436 19.8966 10.0441 19.8966 10.451C19.8966 10.8578 20.2264 11.1876 20.6332 11.1876Z",
    stroke: "#066161",
    strokeWidth: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8435 13.2321H19.6429C19.3667 13.2321 19.135 13.0022 19.2259 12.7414C19.2992 12.5314 19.4191 12.3385 19.5794 12.1782C19.8589 11.8987 20.238 11.7417 20.6333 11.7417C20.8772 11.7416 21.1175 11.8015 21.3328 11.9163",
    stroke: "#066161",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcesspayroll);
export default __webpack_public_path__ + "static/media/Processpayroll.91bbba395fe52b4a72730993730ee197.svg";
export { ForwardRef as ReactComponent };